module.exports = __webpack_public_path__ + "static/media/de.e88d8860.svg";